import React from 'react';

const ZoneFormModal = React.lazy(() => import('../components/FormModal'));
const zoneModalRegistry = {
    crm_zoneId: ZoneFormModal
};
export default zoneModalRegistry;
